import {
  Alert,
  Checkbox,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Select,
  Table,
  Upload,
  Spin
} from "antd";
import Button from "atoms/Button";
import React, { useEffect, useMemo, useState } from "react";
import { useReactToPrint } from "react-to-print";
import styled from "styled-components";
import { ReactComponent as CalendarPickerIcon } from "assets/icons/UI/calendar-picker.svg";
import moment from "moment";
import { useSelector } from "react-redux";
import { getUserInfo, getUserList } from "redux/selectors";
import { UploadOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import { billingOffice, currencyOptions, STATUS_CODE } from "common/Constants";
import { CALL_API } from "common/API";
import { find } from "lodash";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import { ViewClaims } from "./ViewClaims";
import BillingInvoice from "./BillingInvoice";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import userlogo from "../../../assets/bdo logo.svg"

const cursorStyle = { cursor: "pointer" };

const AddNewBilling = () => {
  const userList = useSelector((state) => getUserList(state));
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [base64, setBase64] = useState("");
  const { id } = useParams();
  const { getEngagementById, getClaims } = queryKeys;
  const { key, url } = getEngagementById(id);
  const location = useLocation();
  const {
    record,
    viewbillings = false,
    tabid = "",
    dataList = [],
  } = location.state || {};
  const billingInvoiceDatas = location.state?.billingInvoiceData || null;
  const showBillingInvoiceModal =
    location.state?.showBillingInvoiceModal || false;
  const engagementDataForDirectPreview =
    location.state?.engagementDataForDirectPreview || [];
  const [update, setUpdate] = useState(!!record);
  const [addClaims, setaddClaims] = useState([]);
  const [isViewClims, setIsViewClims] = useState(false);
  const [claimsData, setClaimsData] = useState([]);
  const [internalBillingChecked, setInternalBillingChecked] = useState(false);
  const [isPreviewVisible, setIsPreviewVisible] = useState(false);
  const [formValues, setFormValues] = useState({
    description: record?.description || "",
    amount: record?.amount || "",
    vat: record?.vat || "NON Vat",
  });
  const [billingInvoiceDatass, setBillingInvoiceDatass] = useState({
    billingdate: moment(),
    loerefno: "Loading...",
    contactpersonid: "Loading...",
    contactpersonacid: "Loading...",
    address: "Loading...",
    emailaddress1: "Loading...",
    bdo_pin: "Loading...",
  });
  const [isPrintMode, setIsPrintMode] = useState(false);
  const [form] = Form.useForm();
  const userInfo = useSelector((state) => getUserInfo(state));
  const history = useHistory();
  const activeclaimsIds = dataList?.flatMap((item) =>
    item?.claims?.map((claim) => claim?.claimsId)
  );

  const handleCheckboxChange = (e) => {
    setInternalBillingChecked(e.target.checked);
  };

  const { data: engagementDataRes } = useFetch(key, url, {
    enabled: !!id,
  });
  const engagementData = engagementDataRes?.data;

  const currentYear = new Date().getFullYear();
  const billingOfficeId = engagementData?.financial_resourcePlan?.billingOffice;
  const billingOfficeName = billingOffice.find(
    (office) => office.id === billingOfficeId
  )?.name;

  const userListOptions = userList.map((user) => {
    return {
      label: user.fullname,
      value: user.userid,
    };
  });

  const { key: claimskey, url: claimsurl } = getClaims(
    engagementData?.engagementId,
    engagementData?.clientId
  );

  const { data: getClaimsData } = useFetch(claimskey, claimsurl);

  let claimsDataSource = getClaimsData?.response?.data;

  const handleClaims = () => {
    setIsModalVisible(true);
  };

  const { key: clientKey, url: clienturl } = queryKeys.getClient(
    engagementData?.clientId
  );

  const { data: responses } = useFetch(clientKey, clienturl, {
    endpoint: !!engagementData?.clientId,
  });

  const clientDataRes = useMemo(() => {
    return responses?.response || {};
  }, [responses]);

  console.log("Client Data Response:", clientDataRes, clientDataRes?.client?.["_primarycontactid_value@OData.Community.Display.V1.FormattedValue"]
);

  const initialValues = record
    ? {
      billingdate: record.billingdate ? moment(record.billingdate) : moment(),
      internalbilling: record.internalbilling,
      description: record.description || "",
      currency: record.currency || "",
      amount: parseInt(String(record?.amount || "").replace(/[^\d]/g, ""), 10) || 0,
      vat: record.vat || "",
      financialyear: record.financialyear,
      loerefno: engagementData?.client?.loeRefNo ? engagementData?.client?.loeRefNo : billingInvoiceDatass?.loerefno || "",
      contactpersonid: record.contactpersonid || "",
      contactpersonacid: record.contactpersonacid || "",
      file: record.billingfile
        ? [{ name: record.billingfile.split("/").pop() }]
        : [],
      claims: record?.claims,
    }
    : {
      billingdate: moment(),
      currency: engagementData?.financial_resourcePlan?.currency,
      loerefno: engagementData?.client?.loeRefNo || "",
      contactpersonid: clientDataRes?.client?.["_primarycontactid_value@OData.Community.Display.V1.FormattedValue"] || "",
      contactpersonacid: clientDataRes?.client?.["_primarycontactid_value@OData.Community.Display.V1.FormattedValue"] || "",
      address: clientDataRes?.client?.bdo_registeredaddress || "",
      emailaddress1: clientDataRes?.client?.emailaddress1 || "",
      bdo_pin: clientDataRes?.client?.bdo_pin || "",
      claims: record?.claims,
    };

  useEffect(() => {
    setaddClaims(record?.claims);
  }, []);

  useEffect(() => {
      const updatedData = {
        billingdate: moment(),
        currency: engagementData?.financial_resourcePlan?.currency || "",
        loerefno: engagementData?.client?.loeRefNo || "",
        contactpersonid: clientDataRes.client?.["_primarycontactid_value@OData.Community.Display.V1.FormattedValue"] || "",
        contactpersonacid: clientDataRes.client?.["_primarycontactid_value@OData.Community.Display.V1.FormattedValue"] || "",
        address: clientDataRes.client?.bdo_registeredaddress || "",
        emailaddress1: clientDataRes.client?.emailaddress1 || "",
        bdo_pin: clientDataRes.client?.bdo_pin || "",
        claims: record?.claims,
      };

      setBillingInvoiceDatass(updatedData);

      // ✅ Update form fields dynamically
      form.setFieldsValue(updatedData);
  }, [clientDataRes]);

  useEffect(() => {
      form.setFieldsValue({
        currency: engagementData?.financial_resourcePlan?.currency,
        contactpersonid: clientDataRes.client?.["_primarycontactid_value@OData.Community.Display.V1.FormattedValue"] || "",
        contactpersonacid: clientDataRes.client?.["_primarycontactid_value@OData.Community.Display.V1.FormattedValue"] || "",
      });

    setaddClaims(record?.claims);
  }, [clientDataRes, form]);

  const disablePreviousDates = (current) => {
    return current && current < moment().startOf("day"); // Disable dates before today
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const dataSource = [
    {
      key: 1,
      actionStatus: "Date",
      approvedbyPartner: (
        <>
          {viewbillings || isPrintMode ? (
            <>
              {record?.billingdate
                ? moment(record?.billingdate).format("YYYY-MM-DD")
                : form.getFieldValue("billingdate")
                  ? moment(form.getFieldValue("billingdate")).format("YYYY-MM-DD")
                  : ""}
            </>
          ) : (
            <>
              <Form.Item
                label=""
                name="billingdate"
                rules={[
                  {
                    required: true,
                    message: "Please select Date!",
                  },
                ]}
              >
                <DatePicker
                  // picker="year"
                  style={{ width: "100%" }}
                  placeholder="Select"
                  disabledDate={disablePreviousDates}
                />
              </Form.Item>

              <Form.Item
                name="internalbilling"
                valuePropName="checked"
                wrapperCol={{ offset: 8, span: 16 }}
              >
                <Checkbox disabled={viewbillings} onChange={handleCheckboxChange}>
                  Internal Billing
                </Checkbox>
              </Form.Item>
              {(form.getFieldValue("internalbilling") || internalBillingChecked) && (
                <span className="text-success text-center">
                  This bill will not be sent to finance; it will be sent to the
                  partner only.
                </span>
              )}
            </>
          )}
        </>
      ),
    },
    {
      key: 2,
      actionStatus: "Description",
      approvedbyPartner: (
        <>
          {viewbillings || isPrintMode ? (
            <>{form.getFieldValue("description") || record?.description}</>
          ) : (
            <Form.Item
              label=""
              name="description"
              rules={[
                { required: true, message: "Please input your description!" },
              ]}
            >
              <Input.TextArea
                name="description"
                value={formValues.description}
                onChange={handleInputChange}
                bordered={false}
                placeholder="Description"
                rows={2}
                style={{
                  resize: "none",
                }}
              />
            </Form.Item>
          )}
        </>
      ),
    },
    // {
    //   key: 3,
    //   actionStatus: "Sub Engagements",
    //   approvedbyPartner: (
    //     <>
    //       <Form.Item
    //         label=""
    //         name="subEngagement"
    //         // rules={[
    //         //   {
    //         //     required: true,
    //         //     message: "Please enter Contact Person!",
    //         //   },
    //         // ]}
    //       >
    //         <Select
    //           placeholder="Select"
    //           showSearch={true}
    //           />
    //           </Form.Item>
    //         </>
    //       ),
    // },
    {
      key: 4,
      actionStatus: "Currency",
      approvedbyPartner: (
        <>
          {viewbillings || isPrintMode ? (
            <>{form.getFieldValue("currency") || record?.currency}</>
          ) : (
            <Form.Item
              label=""
              rules={[
                {
                  required: true,
                  message: "Currency is required.",
                },
              ]}
              name="currency"
            >
              {/* <Select placeholder="Select" options={currencyOptions} /> */}
              <Input placeholder="Enter" disabled />
            </Form.Item>
          )}
        </>
      ),
    },
    {
      key: 5,
      actionStatus: "Amount",
      approvedbyPartner: (
        <>
          {viewbillings || isPrintMode ? (
            <>
              {form.getFieldValue("amount") || record?.amount}
              <br />
              {form.getFieldValue("vat") || record?.vat}
            </>
          ) : (
            <Form.Item
              label=""
              name="amount"
              rules={[
                {
                  required: true,
                  message: "Amount is required.",
                },
              ]}
            >
              <Input
                placeholder="Enter"
                name="amount"
                value={formValues.amount}
                onChange={handleInputChange}
                type="number"
              />
            </Form.Item>
          )}
          {!isPrintMode && (
            <Form.Item label="" name="vat">
              <Radio.Group
                disabled={viewbillings}
                value={formValues.vat} // Controlled component
                onChange={(e) =>
                  setFormValues((prev) => ({ ...prev, vat: e.target.value }))
                }
              >
                <Radio value="VAT">VAT</Radio>
                <Radio value="NON Vat">NON Vat</Radio>
              </Radio.Group>
            </Form.Item>
          )}
        </>
      ),
    },
    {
      key: 6,
      actionStatus: "Financial Year",
      approvedbyPartner: (
        <>
          {viewbillings || isPrintMode ? (
            <>
              {
                // Always try to get a value for print/view mode
                (() => {
                  const fy =
                    form.getFieldValue("financialyear") ||
                    record?.financialyear ||
                    initialValues?.financialyear ||
                    currentYear;
                  // If it's a moment object or a date string, format as year
                  if (moment.isMoment(fy)) {
                    return fy.format("YYYY");
                  }
                  if (typeof fy === "string" && fy.length >= 4) {
                    // Try to parse as date
                    const m = moment(fy);
                    if (m.isValid()) return m.format("YYYY");
                    // If it's just a year string, return as is
                    if (/^\d{4}$/.test(fy)) return fy;
                  }
                  if (typeof fy === "number") {
                    return fy;
                  }
                  return currentYear;
                })()
              }
            </>
          ) : (
            <Form.Item
              label=""
              name="financialyear"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please select financial year!",
            //   },
            // ]}
            >
              <Input placeholder="Enter" disabled defaultValue={currentYear} />
            </Form.Item>
          )}
        </>
      ),
    },
    {
      key: 7,
      actionStatus: "LOE Ref No.",
      approvedbyPartner: (
        <>
          {viewbillings || isPrintMode ? (
            <>
              {form.getFieldValue("loerefno") || record?.loerefno || billingInvoiceDatass?.loerefno}
            </>
          ) : (
            <Form.Item
              label=""
              name="loerefno"
              rules={[
                {
                  required: true,
                  message: "LOE Ref No is required.",
                },
              ]}
            >
              <Input placeholder="Enter" defaultValue={record?.loerefno ? record?.loerefno : billingInvoiceDatass?.loerefno} />
            </Form.Item>
          )}
        </>
      ),
    },
    {
      key: 8,
      actionStatus: "Engagement ID",
      approvedbyPartner: (
        <>
          {viewbillings || isPrintMode ? (
            <>{engagementData?.engagementId || "N/A"}</>
          ) : (
            <Form.Item label="" name="engagementId">
              <Input
                placeholder="Enter"
                disabled
                defaultValue={engagementData?.engagementId || "N/A"}
              />
            </Form.Item>
          )}
        </>
      ),
    },
    {
      key: 9,
      actionStatus: "Contact Person",
      approvedbyPartner: (
        <>
          {viewbillings || isPrintMode ? (
            <>
              {
                userListOptions.find(
                  (u) =>
                    u.value ===
                    (form.getFieldValue("contactpersonid") ||
                      record?.contactpersonid)
                )?.label ||
                form.getFieldValue("contactpersonid") ||
                record?.contactpersonid
              }
            </>
          ) : (
            <Form.Item
              label=""
              name="contactpersonid"
              rules={[
                {
                  required: true,
                  message: "Please enter Contact Person!",
                },
              ]}
            >
              <Select
                placeholder="Select"
                disabled
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
                showSearch={true}
                options={userListOptions}
              />
            </Form.Item>
          )}
        </>
      ),
    },
    {
      key: 10,
      actionStatus: "Contact Person A/C",
      approvedbyPartner: (
        <>
          {viewbillings || isPrintMode ? (
            <>
              {
                userListOptions.find(
                  (u) =>
                    u.value ===
                    (form.getFieldValue("contactpersonacid") ||
                      record?.contactpersonacid)
                )?.label ||
                form.getFieldValue("contactpersonacid") ||
                record?.contactpersonacid
              }
            </>
          ) : (
            <Form.Item
              label=""
              name="contactpersonacid"
              rules={[
                {
                  required: true,
                  message: "Please enter Contact Person A/C",
                },
              ]}
            >
              <Select
                placeholder="Select"
                disabled
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
                showSearch={true}
                options={userListOptions}
              />
            </Form.Item>
          )}
        </>
      ),
    },
    {
      key: 11,
      actionStatus: "File Name",
      approvedbyPartner: (
        <>
          {viewbillings || isPrintMode ? (
            <>
              {record?.billingfile
                ? new URL(record?.billingfile).pathname.split("/").pop()
                : form.getFieldValue("file") && form.getFieldValue("file")[0]
                  ? form.getFieldValue("file")[0].name
                  : ""}
            </>
          ) : (
            <Form.Item
              label=""
              name="file"
              valuePropName="fileList"
              getValueFromEvent={(e) =>
                Array.isArray(e) ? e : e && e.fileList
              }
              rules={[
                {
                  required: false,
                  message: "Please upload a file.",
                },
              ]}
            >
              <Upload
                showUploadList={true}
                beforeUpload={(file) => {
                  // Return false to prevent multiple file uploads
                  return !form.getFieldValue(file);
                }}
                maxCount={1}
                customRequest={({ file, onSuccess }) => {
                  // Read the file and convert it to base64
                  const reader = new FileReader();
                  reader.readAsDataURL(file);

                  reader.onload = () => {
                    // Get the base64 data
                    const base64Data = reader.result.split(",")[1];
                    setBase64(base64Data);

                    // Call onSuccess to indicate successful upload
                    onSuccess();

                    // Pass the base64 data to the onChange function
                  };

                  reader.onerror = (error) => {
                    console.error("File read error:", error);
                    // Handle error if needed
                  };
                }}
              >
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
              </Upload>
            </Form.Item>
          )}
        </>
      ),
    },
    {
      key: 12,
      actionStatus: "Select Claims",
      approvedbyPartner: (
        <>
          {isPrintMode ? (
            <span>
              {(addClaims && addClaims.length > 0)
                ? addClaims.map((claim, idx) =>
                  typeof claim === "string"
                    ? claim
                    : claim.claimsId || claim.claimId || claim.id || ""
                ).join(", ")
                : ""}
            </span>
          ) : (
            <Form.Item label="" name="selectclaims">
              {(addClaims?.length > 0 || viewbillings) && (
                <Button
                  style={{ backgroundColor: "#E8E8E8", border: "none" }}
                  loading={loading}
                  onClick={() => setIsViewClims(true)}
                >
                  View Claims
                </Button>
              )}
              {!viewbillings && (
                <Button type="primary" onClick={handleClaims}>
                  Add Claims
                </Button>
              )}
            </Form.Item>
          )}
          {!isPrintMode && (
            <ViewClaims
              isModalVisible={isModalVisible || isViewClims}
              viewClims={isViewClims ? true : false}
              setIsModalVisible={
                isModalVisible ? setIsModalVisible : setIsViewClims
              }
              setaddClaims={setaddClaims}
              addClaims={addClaims}
              claimsDataSource={
                tabid
                  ? record?.claims
                  : isViewClims
                    ? addClaims
                    : claimsDataSource
              }
              isViewClims={isViewClims}
              update={update}
              activeclaimsIds={activeclaimsIds}
            />
          )}
        </>
      ),
    },
  ];

  const getPrintTableDataSource = () => [
    ...dataSource.slice(0, 1),
    {
      key: "billing-type",
      actionStatus: "Billing",
      approvedbyPartner:
        form.getFieldValue("internalbilling") || record?.internalbilling
          ? "Internal Billing (This bill will not be sent to finance; it will be sent to the partner only.)"
          : "External Billing",
    },
    ...dataSource.slice(1),
  ];
  const tableDataSource = isPrintMode ? getPrintTableDataSource() : dataSource;
  const printComponentRef = React.useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const handlePrint = async () => {
    setIsPrintMode(true);
    setIsDownloading(true);
    try {
      if (!printComponentRef.current) return;
      await new Promise((resolve) => setTimeout(resolve, 100));
      const input = printComponentRef.current;
      const canvas = await html2canvas(input, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: "a4",
      });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 40; // 40pt margin on all sides
      const imgWidth = pageWidth - margin * 2;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const maxImgHeight = pageHeight - margin * 2;
      const finalImgHeight = imgHeight > maxImgHeight ? maxImgHeight : imgHeight;
      const finalImgWidth = imgHeight > maxImgHeight
        ? (canvas.width * maxImgHeight) / canvas.height
        : imgWidth;
      const x = (pageWidth - finalImgWidth) / 2;
      const y = (pageHeight - finalImgHeight) / 2;
      pdf.addImage(imgData, "PNG", x, y, finalImgWidth, finalImgHeight);
      pdf.save("Billing Invoice.pdf");
    } finally {
      setIsDownloading(false);
      setIsPrintMode(false);
    }
  };

  const handlePreview = () => {
    setIsPreviewVisible(true);
  };

  const handleCloseInvoicePreviewModal = () => {
    setIsPreviewVisible(false);
  };
  const onFinish = async (form) => {
    try {
      setLoading(true);

      // Ensure amount is treated as a string before calling replace()
      const amountValue = String(form?.amount || "").replace(/\$/g, "");

      const amount =
        parseFloat(amountValue) /
        parseFloat(
          engagementData?.financial_resourcePlan?.conversion_rate ?? 1
        );

      const payload = {
        clientcode: engagementData?.clientId,
        engagementid: engagementData?.engagementId,
        statusid: "1",
        statusname: "Pending",
        engagementPartner: engagementData?.stakeHolder?.partner,
        billingoffice: billingOfficeName,
        userid: userInfo?.userid,
        billingdate: moment(form?.billingdate).format("YYYY-MM-DD"),
        internalbilling: form?.internalbilling,
        description: form?.description,
        currency: form?.currency,
        amount: parseFloat(amountValue), // Ensure amount is parsed properly
        vat: form?.vat,
        financialyear: moment(form?.financialyear).format("YYYY-MM-DD"),
        loerefno: form?.loerefno,
        contactpersonid: form?.contactpersonid,
        contactperson: form?.contactpersonid,
        contactpersonacid: form?.contactpersonacid,
        contactpersonac: form?.contactpersonacid,
        billingfilename: form.file ? form.file[0]?.name : null,
        billingfiletype: form.file ? form.file[0]?.type : null,
        engagementname: engagementData?.information?.jobTitle,
        clientname: engagementData?.client?.clientName,
        content: base64 ?? null,
        billingfile: update ? record.billingfile : "",
        claims: addClaims,
        engagementName: engagementData?.information?.jobTitle,
        clientName: engagementData?.client?.clientName,
        managingoffice: engagementData?.client?.managingOffice,
      };
      const { code } = update
        ? await CALL_API(
          `insyts/billing?engagementid=${record?.engagementid}&billingid=${record?.billingid}`,
          "patch",
          payload
        )
        : await CALL_API(`insyts/billing`, "post", payload);

      setLoading(false);

      if (code === STATUS_CODE.SUCCESS) {
        message.success(update ? "Successfully Updated" : "Successfully Added");
        history.goBack();
      }
    } catch (error) {
      message.error(
        "Something went wrong. Please reach out to our technical team."
      );
      setLoading(false);
      console.error("An error occurred:", error);
    }
  };



  return (
    <BillingWrap>
      {/* <h6><span
        style={cursorStyle}
        className="back"
        onClick={() => {
          history.goBack();
        }}>Back </span> {">"} Add Bill</h6> */}

      {isPreviewVisible && (
        <BillingInvoice
          billingInvoiceData={billingInvoiceDatass}
          open={isPreviewVisible}
          engagementDataForDirectPreview={engagementDataForDirectPreview}
          handleClose={handleCloseInvoicePreviewModal}
          formValues={formValues}
        />
      )}
      <Spin spinning={isDownloading} size="large">
        <Form form={form} onFinish={onFinish} initialValues={initialValues}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <h6>
                <span
                  style={cursorStyle}
                  className="back"
                  onClick={() => {
                    if (tabid) {
                      history.push("/approvals", { tabId: tabid });
                    } else {
                      history.goBack();
                    }
                  }}
                >
                  Back
                </span>{" "}
                {">"}{" "}
                {update ? (viewbillings ? "View Bill" : "Edit Bill") : "Add Bill"}
              </h6>
            </div>
            <div style={{ display: "flex", gap: "8px" }} className="mb-3">
              {!viewbillings && (
                <div>
                  <Button type="primary" className="me-2" onClick={handlePreview}>
                    Preview
                  </Button>
                  <Button type="primary" className="ms-0" onClick={handlePrint} loading={isDownloading}>
                    Print Invoice
                  </Button>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    Submit
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div ref={printComponentRef}>
            {isPrintMode && (
              <>
                <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                  {/* <img src={userlogo} alt="BDO Logo" style={{ width: 80, height: 30, marginRight: 16 }} /> */}
                  <div style={{ flex: 1, textAlign: "center" }}>
                    <div style={{ fontWeight: "bold", fontSize: 18 }}>Amadi</div>
                    <div style={{ fontSize: 14 }}>
                      Country: {engagementData?.client?.managingOffice || "-"}
                    </div>
                  </div>
                </div>
              </>
            )}
            <StyledTable
              columns={[
                {
                  title: "Action/Status",
                  dataIndex: "actionStatus",
                  key: "actionStatus",
                  width: "30%",
                  className: "action-status",
                },
                {
                  title: `${update || viewbillings ? record?.statusname : "pending"
                    }`,
                  dataIndex: "approvedbyPartner",
                  key: "approvedbyPartner",
                  width: "70%",
                },
              ]}
              dataSource={tableDataSource}
              pagination={false}
            />
            <br />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p>Printed By: {userInfo.userid}</p>
              <p>{moment().format('dddd, DD MMMM YYYY')} {' - '}{moment().format('HH:mm:ss')}</p>
            </div>
          </div>
        </Form>
      </Spin>
    </BillingWrap>
  );
};

export default AddNewBilling;

const BillingWrap = styled.div`
  .date-render-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .ant-form-item {
    margin-bottom: 0 !important;
  }

  .ant-checkbox.ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: #02b209 !important;
      border-color: #02b209 !important;
    }
  }
`;

const StyledTable = styled(Table)`
  .ant-table-cell {
    padding: 10px 14px;
  }
  .action-status {
    background-color: #f7f7f8;
  }
  .ant-table-tbody > tr > td,
  .ant-table-thead > tr > th {
    border: 1px solid #dbdbdb;
  }
`;
